import * as Yup from 'yup'

import { localeNames } from '../../../date/date-properties'
import { currencies, licenses } from '../codes'

const validateTimezone = (value?: string): boolean => {
  if (!value) {
    return false
  }

  return localeNames.includes(value!)
}

function validateABN(abn: string): boolean {
  if (!abn) return true

  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]
  const cleanABN = abn.replace(/\D+/g, '')

  if (cleanABN.length !== 11) {
    return false
  }

  const adjustedABN = (parseInt(cleanABN[0]) - 1).toString() + cleanABN.slice(1)

  const sumOfWeights = adjustedABN.split('').reduce((acc, curr, index) => acc + parseInt(curr) * weights[index], 0)

  return sumOfWeights % 89 === 0
}

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().min(2).required(),
  domain: Yup.string().min(2).required(),
  isDemo: Yup.boolean(),
  isTrial: Yup.boolean(),
  timezone: Yup.string().test('invalid-timezone', 'invalid timezone', validateTimezone),
  issuerId: Yup.number().nullable(),
  currency: Yup.mixed().oneOf(currencies),
  licenses: Yup.array().of(Yup.mixed().oneOf(licenses)),
  backOfficeEmail: Yup.array().of(Yup.string().email()),
  defaultTPlusNDays: Yup.number().min(0),
  basisPointFee: Yup.number().min(0),
  enforceSeparationOfDuties: Yup.boolean(),
  requiredRfqSignOffCount: Yup.number().when('enforceSeparationOfDuties', {
    is: true,
    then: Yup.number().required().min(0),
  }),
  segmentCode: Yup.string(),
  passwordExpiryMonths: Yup.number().min(1).max(12).required(),
  capitalBasisEnabled: Yup.boolean(),
  longTermComplianceOnly: Yup.boolean(),
  nationalCode: Yup.string()
    .nullable()
    .optional()
    .transform((value) => {
      if (!value) return null
      return value?.replace(/\D+/g, '')
    })
    .test('invalid-abn', 'Invalid ABN', validateABN),
})
